export { default } from './BrandsCard';
